import { useNavigate } from "react-router-dom";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { CalendarSearch } from "lucide-react";
import { useEffect, useState } from "react";
import {
  fetchAdminLevels,
  getAdminLevel,
  getUserType,
  isAdmin,
  isAllowedDomain,
} from "../utils/userAccess";

import {
  canAccessPage,
  canUploadFiles,
  reservationRules,
} from "../utils/accessRules";
import AppTopBar from "../components/AppTopBar";
import AppFooter from "../components/AppFooter";

export default function BuildingSelection() {
  const navigate = useNavigate();
  const auth = getAuth();
  const [showMenu, setShowMenu] = useState(false);
  const [userData, setUserData] = useState(null);

  const selectBuilding = (building) => {
    navigate(`/reservations/${building}`);
  };

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const email = user.email;

        if (!isAllowedDomain(email)) {
          alert("Access restricted to @uevora.pt or @alunos.uevora.pt accounts.");
          signOut(auth);
          return;
        }

        const adminMap = await fetchAdminLevels();
        const level = getAdminLevel(email, adminMap);
        const type = getUserType(email);

        setUserData({
          email,
          adminLevel: level,
          userType: type,
          canUpload: canUploadFiles(level),
          reservationRules: reservationRules(level),
        });
      }
    });

    return () => unsubscribe();
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.menu-dropdown')) {
        setShowMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="flex flex-col p-6 pt-28 items-center bg-gray-800 text-gray-100 text-center w-full min-h-screen relative">
      <AppTopBar />

      {/* Title */}
      <h1 className="w-full mb-8 text-left px-6 text-xl font-bold">
        Select a Building
      </h1>

      {/* Building Selection Buttons */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <button
          className="bg-blue-600 text-white px-6 py-3 rounded-lg text-lg hover:bg-blue-700"
          onClick={() => selectBuilding("buildingA")}
        >
          Mateus d'Aranda
        </button>
        <button
          className="bg-blue-600 text-white px-6 py-3 rounded-lg text-lg hover:bg-blue-700"
          onClick={() => selectBuilding("buildingB")}
        >
          Complexo dos Leões
        </button>

        {/* 
        <button
          className="bg-blue-600 text-white px-6 py-3 rounded-lg text-lg hover:bg-blue-700"
          onClick={() => selectBuilding("buildingC")}
        >
          Jorge Araújo Library
        </button>
*/}

      </div>

      <AppFooter />
    </div>
  );
}

